import { render, staticRenderFns } from "./error-v2.vue?vue&type=template&id=408d4211&"
import script from "./error-v2.vue?vue&type=script&lang=js&"
export * from "./error-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('408d4211')) {
      api.createRecord('408d4211', component.options)
    } else {
      api.reload('408d4211', component.options)
    }
    module.hot.accept("./error-v2.vue?vue&type=template&id=408d4211&", function () {
      api.rerender('408d4211', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/error-v2.vue"
export default component.exports